var map = {
	"./anthemmr/back.jpg": 350,
	"./avemariamaster/back.jpg": 351,
	"./current/back.jpg": 152,
	"./lmws/back.jpg": 352,
	"./rianoridge/back.jpg": 152,
	"./teravalis/back.jpg": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;